import React, { useState, useEffect } from "react";
import "./EmployeeUsersInUse.scss";
import { InviteModal } from "./InviteModal";

export default function EmployeeUsersInUse({
  title = "Employee Users in Use by Branch Stores",
  users = [],
  onInvite,
  searchTerm = '',
  dealerInfo,
}) {
  const [inviteUser, setInviteUser] = useState(null);
  const PAGE_SIZE = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const term = (searchTerm || '').toLowerCase();

  const filteredUsers = users.filter((u) => {
    if (!term) return true;
    const name = (u.fullName ?? u.name ?? '').toLowerCase();
    const email = (u.email ?? '').toLowerCase();
    return name.includes(term) || email.includes(term);
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredUsers.length / PAGE_SIZE);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  return (
    <section className="employee-users">
      <div className="employee-users-header">
        <h2>{title}</h2>
      </div>

      <div className="employee-users-table-wrapper">
        <table className="employee-users-table">
          <thead>
            <tr>
              <th className="col-user">User</th>
              <th className="col-stores">Representing Store</th>
              <th className="col-invite">Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginatedUsers.map((user, idx) => (
              <tr key={user.id ?? idx}>
                <td className="col-user">
                  <span className="user-name">
                    {user.fullName ?? user.name ?? "—"}
                  </span>
                  <span className="user-email">{user.email}</span>
                </td>

                <td className="col-stores">
                  {(() => {
                    const storesRaw = user.stores;
                    if (!storesRaw) return "—";
                    if (typeof storesRaw === "string" && storesRaw.includes(",")) {
                      return storesRaw.split(",").map((store, idx) => (
                        <div key={idx}>{store.trim()}</div>
                      ));
                    }
                    if (Array.isArray(storesRaw)) {
                      return storesRaw.map((store, idx) => (
                        <div key={idx}>{store}</div>
                      ));
                    }
                    return storesRaw;
                  })()}
                </td>

                <td className="col-invite">
                  <button
                    type="button"
                    className="invite-btn"
                    onClick={() => {
                      setInviteUser(user)
                    }}
                    aria-label={`Invite ${user.fullName ?? user.name ?? user.email}`}
                  >
                    Add user
                  </button>
                </td>
              </tr>
            ))}

            {filteredUsers.length === 0 && (
              <tr>
                <td colSpan={3} className="empty-state">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalPages > 1 && (
          <div className="table-pagination">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span className="table-pagination__info">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
      <InviteModal
        user={inviteUser}
        isOpen={inviteUser}
        onClose={() => setInviteUser(null)}
        onSubmit={(data) => {
          if (onInvite) {
            onInvite(data);
          }
          setInviteUser(null);
        }}
        mode="employeeUsersInUse"
        dealerInfo={dealerInfo}
      />
    </section>
  );
}
